import { render, staticRenderFns } from "./CustomerInfoCheckout.vue?vue&type=template&id=56fa1385&scoped=true&"
import script from "./CustomerInfoCheckout.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoCheckout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoCheckout.vue?vue&type=style&index=0&id=56fa1385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa1385",
  null
  
)

export default component.exports